import * as React from 'react'
import type { CardClosingRequirements } from '@sales-center/common'
import { columns } from './columns'
import { Layout } from '../atoms'
import { SubHeader } from './SubHeader/SubHeader'
import { RequirementsDataGrid } from '../atoms/RequirementsDataGrid.styled'
import { useData } from './useData'

export type Props = {
  billToId: string
  externalLocationId: string
  requirementsAndCounts: CardClosingRequirements
}

export function PaymentsTable(props: Props) {
  const {
    requirementsAndCounts: { paymentsCount },
  } = props

  const { loading, rows } = useData(props)

  return (
    <Layout
      count={paymentsCount}
      title="Cards Captured"
      subHeader={<SubHeader {...props} />}
      dataTestId="paymentsTable"
      table={
        <RequirementsDataGrid
          autoHeight
          disableRowSelectionOnClick
          disableColumnMenu
          hideFooter
          rows={rows}
          columns={columns}
          loading={loading}
          pagination={false}
        />
      }
    />
  )
}
